import { Component } from "react"
import { Mobile, PC, Tablet, Notebook } from "../../ReactiveMode"
import { fadeInAndOut } from "../../../styles/animation"

class Youth extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
    fadeInAndOut()
  }

  render() {
    return (
        <>
          <Mobile>
            <section className="pf-page">
              <div className="youth-clean-header">
                <div className="header-container">
                  <div className="header-content">
                    <div className="header-icon">
                      <img src={`${process.env.REACT_APP_CDN_URL}/images/education/4.png`} alt="청소년부 로고" />
                    </div>
                    <h1>청소년부</h1>
                    <p>믿음의 뿌리를 깊게, 정체성을 굳게</p>
                  </div>
                </div>
              </div>

              <section className="youth-clean-content mobile-content">
                <div className="content-wrapper">
                  {/* 청소년부 소개 */}
                  <div className="section mobile-section">
                    <div className="section-header">
                      <h2>청소년부 소개</h2>
                    </div>
                    <div className="intro-card mobile-intro">
                      <div className="card-content">
                        <div className="icon-wrapper">
                          <i className="fas fa-seedling"></i>
                        </div>
                        <div className="text-content">
                          <p className="main-text">
                            "믿음의 뿌리를 깊게, 정체성을 굳게, 세상 속에서도 흔들림 없는 나무로"
                          </p>
                          <p className="sub-text">
                            청소년부는 세상 속에서 흔들리는 질문들 가운데 신앙의 정체성을 확립하는 시기입니다. 하나님의
                            말씀을 기준 삼아 사고하고 결정하며, 예배와 공동체 안에서 진짜 믿음으로 뿌리내립니다.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 표어 */}
                  <div className="section mobile-section">
                    <div className="motto-card">
                      <div className="motto-icon">
                        <i className="fas fa-hands-helping"></i>
                      </div>
                      <h3>함께 지어져 가네</h3>
                    </div>
                  </div>

                  {/* 예배 안내 */}
                  <div className="section mobile-section">
                    <div className="section-header">
                      <h2>예배 안내</h2>
                    </div>
                    <div className="worship-grid mobile-worship">
                      <div className="worship-card">
                        <div className="worship-header">
                          <div className="worship-icon">
                            <i className="fas fa-church"></i>
                          </div>
                          <h3>주일 예배</h3>
                        </div>
                        <div className="worship-content">
                          <div className="worship-info">
                            <div className="info-item">
                              <i className="fas fa-clock"></i>
                              <span>매주 일요일 오전 11시 30분</span>
                            </div>
                            <div className="info-item">
                              <i className="fas fa-map-marker-alt"></i>
                              <span>성실교회 교육관 4층 청소년부실</span>
                            </div>
                            <div className="info-item">
                              <i className="fas fa-users"></i>
                              <span>중, 고등학생</span>
                            </div>
                          </div>
                          <div className="worship-order-simple">
                            <h4>예배 순서</h4>
                            <p>
                              사도신경 - 경배와 찬양 - 대표기도 - 성경봉독 - 말씀 - 헌금 - 헌금기도 - 주기도문 - 광고 -
                              2부순서
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 주제성구 */}
                  <div className="section mobile-section">
                    <div className="scripture-card">
                      <div className="scripture-icon">
                        <i className="fas fa-bible"></i>
                      </div>
                      <div className="scripture-content">
                        <p className="scripture-text">
                          "너희도 성령 안에서 하나님이 거하실 처소가 되기 위하여 그리스도 예수 안에서 함께 지어져
                          가느니라"
                        </p>
                        <p className="scripture-reference">에베소서 2장 22절</p>
                      </div>
                    </div>
                  </div>

                  {/* 교육목표 */}
                  <div className="section mobile-section">
                    <div className="section-header">
                      <h2>교육목표</h2>
                    </div>
                    <div className="goals-grid mobile-goals">
                      <div className="goal-card">
                        <div className="goal-icon">
                          <i className="fas fa-praying-hands"></i>
                        </div>
                        <h3>하나님과의 온전한 관계</h3>
                        <p>하나님과 더욱 가까이 하는 청소년부</p>
                      </div>
                      <div className="goal-card">
                        <div className="goal-icon">
                          <i className="fas fa-chalkboard-teacher"></i>
                        </div>
                        <h3>선생님과의 관계</h3>
                        <p>교제하고 배워가는 청소년부</p>
                      </div>
                      <div className="goal-card">
                        <div className="goal-icon">
                          <i className="fas fa-user-friends"></i>
                        </div>
                        <h3>친구들과의 관계</h3>
                        <p>함께 하기에 더욱 즐거운 청소년부</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </section>
          </Mobile>

          <Tablet>
            <section className="pf-page">
              <div className="youth-clean-header">
                <div className="header-container">
                  <div className="header-content">
                    <div className="header-icon">
                      <img src={`${process.env.REACT_APP_CDN_URL}/images/education/4.png`} alt="청소년부 로고" />
                    </div>
                    <h1>청소년부</h1>
                    <p>믿음의 뿌리를 깊게, 정체성을 굳게</p>
                  </div>
                </div>
              </div>

              <section className="youth-clean-content tablet-content">
                <div className="content-wrapper">
                  {/* 청소년부 소개 */}
                  <div className="section">
                    <div className="section-header">
                      <h2>청소년부 소개</h2>
                    </div>
                    <div className="intro-card tablet-intro">
                      <div className="card-content">
                        <div className="icon-wrapper">
                          <i className="fas fa-seedling"></i>
                        </div>
                        <div className="text-content">
                          <p className="main-text">
                            "믿음의 뿌리를 깊게, 정체성을 굳게, 세상 속에서도 흔들림 없는 나무로"
                          </p>
                          <p className="sub-text">
                            청소년부는 세상 속에서 흔들리는 질문들 가운데 신앙의 정체성을 확립하는 시기입니다. 하나님의
                            말씀을 기준 삼아 사고하고 결정하며, 예배와 공동체 안에서 진짜 믿음으로 뿌리내립니다.
                            청소년부는 학생들이 자신의 신앙을 분명히 하고, 하나님 나라의 청지기로서 자라가도록 이끄는
                            믿음의 훈련소입니다.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 표어 & 예배 안내 */}
                  <div className="section">
                    <div className="two-column-grid">
                      <div className="motto-card">
                        <div className="motto-icon">
                          <i className="fas fa-hands-helping"></i>
                        </div>
                        <h3>함께 지어져 가네</h3>
                      </div>
                      <div className="worship-card">
                        <div className="worship-header">
                          <div className="worship-icon">
                            <i className="fas fa-church"></i>
                          </div>
                          <h3>예배 안내</h3>
                        </div>
                        <div className="worship-content">
                          <div className="worship-info">
                            <div className="info-item">
                              <i className="fas fa-clock"></i>
                              <span>매주 일요일 오전 11시 30분</span>
                            </div>
                            <div className="info-item">
                              <i className="fas fa-map-marker-alt"></i>
                              <span>성실교회 교육관 4층 청소년부실</span>
                            </div>
                            <div className="info-item">
                              <i className="fas fa-users"></i>
                              <span>중, 고등학생</span>
                            </div>
                          </div>
                          <div className="worship-order-simple">
                            <h4>예배 순서</h4>
                            <p>
                              사도신경 - 경배와 찬양 - 대표기도 - 성경봉독 - 말씀 - 헌금 - 헌금기도 - 주기도문 - 광고 -
                              2부순서
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 주제성구 */}
                  <div className="section">
                    <div className="scripture-card">
                      <div className="scripture-icon">
                        <i className="fas fa-bible"></i>
                      </div>
                      <div className="scripture-content">
                        <p className="scripture-text">
                          "너희도 성령 안에서 하나님이 거하실 처소가 되기 위하여 그리스도 예수 안에서 함께 지어져
                          가느니라"
                        </p>
                        <p className="scripture-reference">에베소서 2장 22절</p>
                      </div>
                    </div>
                  </div>

                  {/* 교육목표 */}
                  <div className="section">
                    <div className="section-header">
                      <h2>교육목표</h2>
                    </div>
                    <div className="goals-section">
                      <div className="goals-list">
                        <div className="goal-item">
                          <i className="fas fa-praying-hands"></i>
                          <span>하나님과의 온전한 관계</span>
                        </div>
                        <div className="goal-item">
                          <i className="fas fa-chalkboard-teacher"></i>
                          <span>선생님과의 관계</span>
                        </div>
                        <div className="goal-item">
                          <i className="fas fa-user-friends"></i>
                          <span>친구들과의 관계</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </section>
          </Tablet>

          <Notebook>
            <section className="pf-page">
              <div className="youth-clean-header">
                <div className="header-container">
                  <div className="header-content">
                    <div className="header-icon">
                      <img src={`${process.env.REACT_APP_CDN_URL}/images/education/4.png`} alt="청소년부 로고" />
                    </div>
                    <h1>청소년부</h1>
                    <p>믿음의 뿌리를 깊게, 정체성을 굳게, 세상 속에서도 흔들림 없는 나무로</p>
                  </div>
                </div>
              </div>

              <section className="youth-clean-content">
                <div className="content-wrapper">
                  {/* 청소년부 소개 */}
                  <div className="section">
                    <div className="section-header">
                      <h2>청소년부 소개</h2>
                    </div>
                    <div className="intro-card">
                      <div className="card-content">
                        <div className="icon-wrapper">
                          <i className="fas fa-seedling"></i>
                        </div>
                        <div className="text-content">
                          <p className="main-text">
                            "믿음의 뿌리를 깊게, 정체성을 굳게, 세상 속에서도 흔들림 없는 나무로"
                          </p>
                          <p className="sub-text">
                            청소년부는 세상 속에서 흔들리는 질문들 가운데 신앙의 정체성을 확립하는 시기입니다. 하나님의
                            말씀을 기준 삼아 사고하고 결정하며, 예배와 공동체 안에서 진짜 믿음으로 뿌리내립니다.
                            청소년부는 학생들이 자신의 신앙을 분명히 하고, 하나님 나라의 청지기로서 자라가도록 이끄는
                            믿음의 훈련소입니다.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 표어 */}
                  <div className="section">
                    <div className="motto-card">
                      <div className="motto-icon">
                        <i className="fas fa-hands-helping"></i>
                      </div>
                      <h3>함께 지어져 가네</h3>
                    </div>
                  </div>

                  {/* 예배 안내 */}
                  <div className="section">
                    <div className="section-header">
                      <h2>예배 안내</h2>
                    </div>
                    <div className="worship-grid notebook-worship">
                      <div className="worship-card">
                        <div className="worship-header">
                          <div className="worship-icon">
                            <i className="fas fa-church"></i>
                          </div>
                          <h3>주일 예배</h3>
                        </div>
                        <div className="worship-content">
                          <div className="worship-info">
                            <div className="info-item">
                              <i className="fas fa-clock"></i>
                              <span>매주 일요일 오전 11시 30분</span>
                            </div>
                            <div className="info-item">
                              <i className="fas fa-map-marker-alt"></i>
                              <span>성실교회 교육관 4층 청소년부실</span>
                            </div>
                            <div className="info-item">
                              <i className="fas fa-users"></i>
                              <span>중, 고등학생</span>
                            </div>
                          </div>
                          <div className="worship-order-simple">
                            <h4>예배 순서</h4>
                            <p>
                              사도신경 - 경배와 찬양 - 대표기도 - 성경봉독 - 말씀 - 헌금 - 헌금기도 - 주기도문 - 광고 -
                              2부순서
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 주제성구 */}
                  <div className="section">
                    <div className="section-header">
                      <h2>주제성구</h2>
                    </div>
                    <div className="scripture-card">
                      <div className="scripture-icon">
                        <i className="fas fa-bible"></i>
                      </div>
                      <div className="scripture-content">
                        <p className="scripture-text">
                          "너희도 성령 안에서 하나님이 거하실 처소가 되기 위하여 그리스도 예수 안에서 함께 지어져
                          가느니라"
                        </p>
                        <p className="scripture-reference">에베소서 2장 22절</p>
                      </div>
                    </div>
                  </div>

                  {/* 교육목표 */}
                  <div className="section">
                    <div className="section-header">
                      <h2>교육목표</h2>
                    </div>
                    <div className="goals-grid notebook-goals">
                      <div className="goal-card">
                        <div className="goal-icon">
                          <i className="fas fa-praying-hands"></i>
                        </div>
                        <h3>하나님과의 온전한 관계를 이루어</h3>
                        <p>하나님과 더욱 가까이 하는 청소년부</p>
                      </div>
                      <div className="goal-card">
                        <div className="goal-icon">
                          <i className="fas fa-chalkboard-teacher"></i>
                        </div>
                        <h3>선생님과의 관계를 이루어</h3>
                        <p>교제하고 배워가는 청소년부</p>
                      </div>
                      <div className="goal-card">
                        <div className="goal-icon">
                          <i className="fas fa-user-friends"></i>
                        </div>
                        <h3>친구들과의 관계를 이루어</h3>
                        <p>함께 하기에 더욱 즐거운 청소년부</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </section>
          </Notebook>

          <PC>
            <section className="pf-page">
              <div className="youth-clean-header">
                <div className="header-container">
                  <div className="header-content">
                    <div className="header-icon">
                      <img src={`${process.env.REACT_APP_CDN_URL}/images/education/4.png`} alt="청소년부 로고" />
                    </div>
                    <h1>청소년부</h1>
                    <p>믿음의 뿌리를 깊게, 정체성을 굳게, 세상 속에서도 흔들림 없는 나무로</p>
                  </div>
                </div>
              </div>

              <section className="youth-clean-content">
                <div className="content-wrapper">
                  {/* 청소년부 소개 */}
                  <div className="section">
                    <div className="section-header">
                      <h2>청소년부 소개</h2>
                    </div>
                    <div className="intro-card">
                      <div className="card-content">
                        <div className="icon-wrapper">
                          <i className="fas fa-seedling"></i>
                        </div>
                        <div className="text-content">
                          <p className="main-text">
                            "믿음의 뿌리를 깊게, 정체성을 굳게, 세상 속에서도 흔들림 없는 나무로"
                          </p>
                          <p className="sub-text">
                            청소년부는 세상 속에서 흔들리는 질문들 가운데 신앙의 정체성을 확립하는 시기입니다. 하나님의
                            말씀을 기준 삼아 사고하고 결정하며, 예배와 공동체 안에서 진짜 믿음으로 뿌리내립니다.
                            청소년부는 학생들이 자신의 신앙을 분명히 하고, 하나님 나라의 청지기로서 자라가도록 이끄는
                            믿음의 훈련소입니다.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 표어 */}
                  <div className="section">
                    <div className="motto-card">
                      <div className="motto-icon">
                        <i className="fas fa-hands-helping"></i>
                      </div>
                      <h3>함께 지어져 가네</h3>
                    </div>
                  </div>

                  {/* 예배 안내 */}
                  <div className="section">
                    <div className="section-header">
                      <h2>예배 안내</h2>
                    </div>
                    <div className="worship-grid">
                      <div className="worship-card">
                        <div className="worship-header">
                          <div className="worship-icon">
                            <i className="fas fa-church"></i>
                          </div>
                          <h3>주일 예배</h3>
                        </div>
                        <div className="worship-content">
                          <p>청소년부 주일 예배는 청소년들의 눈높이에 맞춘 말씀과 찬양으로 드려집니다.</p>
                          <div className="worship-info">
                            <div className="info-item">
                              <i className="fas fa-clock"></i>
                              <span>매주 일요일 오전 11시 30분</span>
                            </div>
                            <div className="info-item">
                              <i className="fas fa-map-marker-alt"></i>
                              <span>성실교회 교육관 4층 청소년부실</span>
                            </div>
                            <div className="info-item">
                              <i className="fas fa-users"></i>
                              <span>중, 고등학생</span>
                            </div>
                          </div>
                          <div className="worship-order-simple">
                            <h4>예배 순서</h4>
                            <p>
                              사도신경 - 경배와 찬양 - 대표기도 - 성경봉독 - 말씀 - 헌금 - 헌금기도 - 주기도문 - 광고 -
                              2부순서
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 주제성구 */}
                  <div className="section">
                    <div className="section-header">
                      <h2>주제성구</h2>
                    </div>
                    <div className="scripture-card">
                      <div className="scripture-icon">
                        <i className="fas fa-bible"></i>
                      </div>
                      <div className="scripture-content">
                        <p className="scripture-text">
                          "너희도 성령 안에서 하나님이 거하실 처소가 되기 위하여 그리스도 예수 안에서 함께 지어져
                          가느니라"
                        </p>
                        <p className="scripture-reference">에베소서 2장 22절</p>
                      </div>
                    </div>
                  </div>

                  {/* 교육목표 */}
                  <div className="section">
                    <div className="section-header">
                      <h2>교육목표</h2>
                    </div>
                    <div className="goals-grid">
                      <div className="goal-card">
                        <div className="goal-icon">
                          <i className="fas fa-praying-hands"></i>
                        </div>
                        <h3>하나님과의 온전한 관계를 이루어</h3>
                        <p>하나님과 더욱 가까이 하는 청소년부</p>
                      </div>
                      <div className="goal-card">
                        <div className="goal-icon">
                          <i className="fas fa-chalkboard-teacher"></i>
                        </div>
                        <h3>선생님과의 관계를 이루어</h3>
                        <p>교제하고 배워가는 청소년부</p>
                      </div>
                      <div className="goal-card">
                        <div className="goal-icon">
                          <i className="fas fa-user-friends"></i>
                        </div>
                        <h3>친구들과의 관계를 이루어</h3>
                        <p>함께 하기에 더욱 즐거운 청소년부</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </section>
          </PC>
        </>
    )
  }
}

export default Youth
